import { schema } from "normalizr";

export const searchPreviewSchema = new schema.Entity(
  'searchPreviews',
  {},
  {
    idAttribute: (item) => `${item.searchable.kind}-${item.searchable.id}`
  }
);
